<ng-container *ngIf="vm$ | async as vm">
  <app-radio-button-group *ngIf="vm.display" [selectedIndex]="vm.selectedIndex" size="small" inline>
    <app-radio-button-item (click)="setMinmax(GraphModes.DEFAULT)" [selected]="vm.selectedIndex === 0">
      <app-radio-button-label 
        [text]="'station-app.__WS_INFO_4_LABEL1' | AsyncLang | async"
      ></app-radio-button-label>
    </app-radio-button-item>

    <app-radio-button-item (click)="setMinmax(GraphModes.MINMAX)" [selected]="vm.selectedIndex === 1">
      <app-radio-button-label 
        [text]="('station-app.__DASHBOARD_TITLE_MINIMUM_TEMPERATURE' | AsyncLang | async) + '/' + ('station-app.__DASHBOARD_TITLE_MAXIMUM_TEMPERATURE' | AsyncLang | async)"
      ></app-radio-button-label>
    </app-radio-button-item>
  </app-radio-button-group>
</ng-container>